import React from 'react';
import Badge from '../Badge/Badge';
import Tooltip from '../Tooltip';
import { formatDate } from '../../../utils/formatting';

interface PregnantStudentBadgeProps {
  visible?: boolean | null;
  pregnantUntil?: string | null;
  className?: string;
}

const PregnantStudentBadge: React.FC<PregnantStudentBadgeProps> = ({
  visible,
  pregnantUntil,
  className,
}) => {
  if (!visible) {
    return null;
  }

  const untilLabel = pregnantUntil?.trim()
    ? `até ${formatDate(pregnantUntil.trim().slice(0, 10))}`
    : null;

  return (
    <Tooltip content={untilLabel}>
      <Badge variant="pregnant" solid className={className}>
        Grávida
      </Badge>
    </Tooltip>
  );
};

export default PregnantStudentBadge;
